// Plan-gated feature prompt, same props as the shared UpgradeFeatureModal,
// rendered with the redesign's dialog.
import { useNavigate } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';
import { Button, Modal } from './ui';

interface UpgradeFeatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureName: string;
  description: string;
  requiredPlan: 'Basic' | 'Pro';
}

// Mounted only while open, so a closed prompt needs no router (it sits inside
// components that are also rendered on their own, e.g. in unit tests).
export const UpgradeFeatureModal: React.FC<UpgradeFeatureModalProps> = (props) => (props.isOpen ? <OpenUpgradeModal {...props} /> : null);

const OpenUpgradeModal: React.FC<UpgradeFeatureModalProps> = ({ onClose, featureName, description, requiredPlan }) => {
  const navigate = useNavigate();
  return (
    <Modal open onClose={onClose} title={`Unlock ${featureName}`} width={460}>
      <div className="flex gap-3.5">
        <span className="w-11 h-11 rounded-[13px] bg-amb-bg text-amb flex items-center justify-center shrink-0" aria-hidden="true">
          <LockKeyhole size={20} />
        </span>
        <div>
          <p className="text-[14px] text-t3 leading-[1.55]">{description}</p>
          <p className="mt-2.5 text-[14px] font-semibold">Available on {requiredPlan} plans and above.</p>
        </div>
      </div>
      <div className="flex gap-2.5 mt-[22px]">
        <Button variant="ghost" shape="form" size="lg" onClick={onClose}>
          Not now
        </Button>
        <Button shape="form" size="lg" className="flex-1" onClick={() => navigate('/admin/subscription')} data-testid="upgrade-feature-cta">
          See plans
        </Button>
      </div>
    </Modal>
  );
};
